import { GUJARATSAMAGRACITY_FETCH_DATA_SUCCESS, GUJARATSAMAGRACITY_HAVE_ERROR, GUJARATSAMAGRACITY_ARE_LOADING } from '../actionType';

import HttpService from '../../utils/httpService';
import { Get } from '../../services/api.service'

export function GujaratSamagraCityAction(action, payload) {
    switch (action) {
        case GUJARATSAMAGRACITY_HAVE_ERROR:
            return {
                type: action,
                hasError: payload
            };
    
        case GUJARATSAMAGRACITY_ARE_LOADING:
            return {
                type: action,
                isLoading: payload
            };
    
        case GUJARATSAMAGRACITY_FETCH_DATA_SUCCESS:
            return {
                type: action,
                GujaratSamagraCity: payload,
            };

        default:
            return;
    }
}

export function GujaratSamagraCityFetchData() {
    return (dispatch) => {
        try {
            return new Promise((resolve, reject) => {
                dispatch(GujaratSamagraCityAction(GUJARATSAMAGRACITY_ARE_LOADING, true));
                Get(`${HttpService.gujaratSamagraCity}`).then((result) => {
                    dispatch(GujaratSamagraCityAction(GUJARATSAMAGRACITY_FETCH_DATA_SUCCESS, result.data));
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            });
        } catch (error) {
            dispatch(GujaratSamagraCityAction(GUJARATSAMAGRACITY_HAVE_ERROR, true));
        }
    }
}
